import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import type { ApiEnvelope } from '@/types/api';
import type { AuthUser, LoginResponse } from '@/types/auth';

export async function login(email: string, password: string): Promise<LoginResponse> {
  try {
    const res = await http.post<ApiEnvelope<LoginResponse>>('/auth/login', { email, password });
    return unwrap(res.data);
  } catch (error) {
    throw toApiError(error);
  }
}

export async function fetchMe(): Promise<AuthUser> {
  try {
    const res = await http.get<ApiEnvelope<AuthUser>>('/me');
    return unwrap(res.data);
  } catch (error) {
    throw toApiError(error);
  }
}
